
export default function Logout(){
    sessionStorage.clear();
    localStorage.clear();
    window.location.assign('/');
}


